import { graphql, useStaticQuery } from "gatsby"
import React from "react"

import { Client } from "../vignettes/Client"

export default function ClientsList({ locale }) {
  const { clients_fr, clients_en } = useStaticQuery(graphql`
    query ClientsListQueryFr {
      clients_fr: allWpClient(
        filter: { language: { locale: { eq: "fr_FR" } } }
        sort: { modified: DESC }
      ) {
        nodes {
          ...ClientFragment
        }
      }
      clients_en: allWpClient(
        filter: { language: { locale: { eq: "en_GB" } } }
        sort: { modified: DESC }
      ) {
        nodes {
          ...ClientFragment
        }
      }
    }
  `)
  const clients = locale === "fr_FR" ? clients_fr.nodes : clients_en.nodes

  return (
    <div className="bg-charlestonGreen-100">
      <div className="relative">
        <div className="px-4 pb-16 mx-auto sm:px-6 max-w-6xl sm:pb-24 pt-12">
          <div className="relative grid max-w-lg gap-5 mx-auto lg:grid-cols-3 lg:max-w-none">
            {clients.map(client => (
              <Client key={client.id} client={client} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
